module.exports = __webpack_public_path__ + "static/media/Adam_Pearl-Headshot.ee5f25e5.jpg";